import { useEffect } from 'react';
import { configSettings } from '@/lib/config';

/**
 * Stripe Connect OAuth callback lands at `<origin>/oauth?code=...&state=...&scope=...`.
 * The callback handler lives in the Vue admin (vue/src/pages/oauth/index.vue) which
 * POSTs to /v1/integrations/stripe/connect/oauth. Bounce to Vue preserving the query.
 */
const OauthRedirectPage = () => {
    useEffect(() => {
        const legacyDomain = configSettings.legacyAdminDomain?.replace(/\/+$/, '');
        if (!legacyDomain) return;
        window.location.href = `${legacyDomain}/oauth${window.location.search}`;
    }, []);

    return null;
};

export default OauthRedirectPage;
